module.exports = __webpack_public_path__ + "img/newspapers-g54e3bc794_1920.0d1893e7.jpg";